export const ITEM = 'masonry-grid-item';
